import { STATE_CLASS, STATE_LABEL } from "../../texte";

export function Badge({ state }: { state: string }) {
  return (
    <span className={`badge ${STATE_CLASS[state] ?? ""}`}>
      <span className="dot" />
      {STATE_LABEL[state] ?? state}
    </span>
  );
}
